module.exports = __webpack_public_path__ + "img/certificate6.8fb3e288.png";